import React from 'react';
import { useParams } from 'react-router-dom';
import './ExtrasPage.css';

const ExtrasPage = () => {
    const { tripId } = useParams();

    return (
        <div className="extras-container">
            <div className="extras-content">
                <h1 className="extras-title">Trip Extras</h1>
                <p className="extras-description">
                    This section will contain additional features and options for your trip.
                </p>
                
                <div className="extras-coming-soon">
                    <h2>Coming Soon</h2>
                    <p>We're working on adding more features to help you plan your perfect trip.</p>
                    <ul className="extras-features-list">
                        <li>Trip Budget Tracking</li>
                        <li>Packing Lists</li>
                        <li>Weather Forecasts</li>
                        <li>Currency Conversion</li>
                        <li>Local Recommendations</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ExtrasPage; 